export default IconBadgesOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-badges-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14.505 14.497l-2.505 1.503l-5 -3v4l5 3l5 -3" />
  <path d="M13.873 9.876l3.127 -1.876v-4l-5 3l-2.492 -1.495m-2.508 1.495v1l2.492 1.495" />
  <path d="M3 3l18 18" />
</svg>`;